import { ArgsProps } from 'antd/es/notification/interface';
import { toast } from 'sonner';

/**
 * Drop-in replacement for antd's `notification` API that renders through sonner
 * (mounted globally in the app shell). antd notifications carry a `message`
 * (title) and `description` (body); sonner maps these to its title + description
 * slots so request-layer feedback matches the app-wide toast style.
 */

const toSonnerDuration = (duration?: number): number | undefined => {
  if (duration === undefined) return undefined;
  if (duration === 0) return Infinity;
  return duration * 1000;
};

const buildOptions = (args: ArgsProps) => ({
  // antd notifications carry a `key` for later close/destroy; map it to sonner's
  // id so notification.close(key) / destroy(key) targets the created toast.
  id: args.key as string | number | undefined,
  description: args.description,
  duration: toSonnerDuration(args.duration ?? undefined),
  onAutoClose: args.onClose,
  onDismiss: args.onClose,
});

const notification = {
  open: (args: ArgsProps) => toast(args.message, buildOptions(args)),
  success: (args: ArgsProps) => toast.success(args.message, buildOptions(args)),
  error: (args: ArgsProps) => toast.error(args.message, buildOptions(args)),
  info: (args: ArgsProps) => toast.info(args.message, buildOptions(args)),
  warning: (args: ArgsProps) => toast.warning(args.message, buildOptions(args)),

  config: () => {},
  destroy: (key?: string | number) => toast.dismiss(key),
  close: (key: string | number) => toast.dismiss(key),
};

export default notification;
